import { createAction, handleActions } from 'redux-actions'

const setEmails = createAction('SCREENS/EMAILS/SET_EMAILS')
const clearEmails = createAction('SCREENS/EMAILS/CLEAR_EMAILS')

const defaultState = []

const reducer = handleActions(
  {
    [setEmails]: (state, action) => action.payload,
    [clearEmails]: () => defaultState,
  },
  defaultState,
)
// || null
export { setEmails, clearEmails, reducer }
